import { gql } from "@apollo/client";
import { Job as job } from "../fragments";

const FETCH_JOB_REQUEST = props => gql`
  query FetchJob($id: Int!) {
    job(id: $id) {
      ${job(props)}
    }
  }
`;

const FETCH_JOB_REQUESTS_V2 = props => gql`
  query FetchJobsV2($input: AdvJobFilterInput!) {
    jobsV2(input: $input) {
      count
      edges {
        ${job(props)}
      }
      sqlQuery
    }
  }
`;

const FETCH_JOBS_LIST = gql`
  query FetchJobsV2($input: AdvJobFilterInput!) {
    jobsV2(input: $input) {
      count
      edges {
        id
        date
        description
        dueDate
        duetime
        jobStatus {
          description
        }
        jobType {
          description
        }
        pickupGroup {
          name
        }
      }
    }
  }
`;

export { FETCH_JOB_REQUEST, FETCH_JOB_REQUESTS_V2, FETCH_JOBS_LIST };
